import { Injectable, inject } from '@angular/core';
// import {Actions, Effect, ofType} from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes, GetShopCountByLocation, GetShopCountByLocationError,
	GetShopCountByLocationSuccess,
	LocationByLatLong,
	LocationByLatLongError,
	LocationByLatLongSuccess, MarketplaceAnalytics, MarketplaceAnalyticsError, MarketplaceAnalyticsSuccess
} from "./location.actions";
import { Helper } from "../../shared/services/Helper.service";
import { LocationService } from "../../core/services/location.service";

@Injectable()
export class LocationEffects {

	// @Effect()
	// LocationByLatLong$ = this.actions$.pipe(
	LocationByLatLong$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LocationByLatLong),
			map((action: LocationByLatLong) => action.payload),
			mergeMap((payload) => {
				return this.locationService.LocationByLatLong(payload).pipe(
					map((response) => {
						return new LocationByLatLongSuccess(response)
					}),
					catchError((error) => of(new LocationByLatLongError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// LocationByLatLongSuccess$ = this.actions$.pipe(
	LocationByLatLongSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LocationByLatLongSuccess),
			map((action: LocationByLatLongSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// LocationByLatLongError$ = this.actions$.pipe(
	LocationByLatLongError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LocationByLatLongError),
			map((action: LocationByLatLongError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetShopCountByLocation$ = this.actions$.pipe(
	GetShopCountByLocation$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShopCountByLocation),
			map((action: GetShopCountByLocation) => action.payload),
			mergeMap((payload) => {
				return this.locationService.GetShopCountByLocation(payload).pipe(
					map((response) => {
						return new GetShopCountByLocationSuccess(response)
					}),
					catchError((error) => of(new GetShopCountByLocationError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetShopCountByLocationSuccess$ = this.actions$.pipe(
	GetShopCountByLocationSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShopCountByLocationSuccess),
			map((action: GetShopCountByLocationSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetShopCountByLocationError$ = this.actions$.pipe(
	GetShopCountByLocationError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShopCountByLocationError),
			map((action: GetShopCountByLocationError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// MarketplaceAnalytics$ = this.actions$.pipe(
	MarketplaceAnalytics$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.MarketplaceAnalytics),
			map((action: MarketplaceAnalytics) => action.payload),
			mergeMap((payload) => {
				return this.locationService.MarketplaceAnalytics().pipe(
					map((response) => {
						return new MarketplaceAnalyticsSuccess(response)
					}),
					catchError((error) => of(new MarketplaceAnalyticsError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// MarketplaceAnalyticsSuccess$ = this.actions$.pipe(
	MarketplaceAnalyticsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.MarketplaceAnalyticsSuccess),
			map((action: MarketplaceAnalyticsSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// MarketplaceAnalyticsError$ = this.actions$.pipe(
	MarketplaceAnalyticsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.MarketplaceAnalyticsError),
			map((action: MarketplaceAnalyticsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private locationService: LocationService,
	) {
	}
}
